import { z } from 'zod';
import { isValidCNPJ } from '../utils/formatDocuments';

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' };
  }

  return { message: ctx.defaultError };
});

export const enderecoSchema = z.object({

  id: z.number().optional(),

  estado: z
    .string()
    .refine(value => value.trim() !== '', 'O estado não pode ser vazio'),

  cidade: z
    .string()
    .min(3, 'A cidade deve ter no mínimo 3 caracteres')
    .refine(value => value.trim() !== '', 'A cidade não pode ser vazia'),

  cep: z
    .string()
    .min(3, 'O CEP deve ter no mínimo 3 caracteres'),


  rua: z
    .string()
    .min(3, 'A rua deve ter no mínimo 3 caracteres')
    .refine(value => value.trim() !== '', 'A rua não pode ser vazia'),

  numero: z
    .string()
    .optional(),

  complemento: z
    .string()
    .optional(),

  bairro: z
    .string()
    .min(3, 'O bairro deve ter no mínimo 3 caracteres')
    .refine(value => value.trim() !== '', 'O bairro não pode ser vazio'),
});

export const contatoSchema = z.object({
  telefone: z
    .string()
    .min(3, 'O telefone deve ter no mínimo 3 caracteres')
    .refine(value => value.trim() !== '', 'O telefone não pode ser vazio'),

  email: z
    .string()
    .email('O e-mail deve ser válido')
    .refine(value => value.trim() !== '', 'O e-mail não pode ser vazio'),
});

export const unitsSchema = z.object({
  id: z.number().int().optional(),
  nomeFantasia: z
    .string()
    .min(3, 'O nome fantasia deve ter no mínimo 3 caracteres')
    .refine(value => value.trim() !== '', 'O nome fantasia não pode ser vazio'),

  razaoSocial: z
    .string()
    .min(3, 'A razão social deve ter no mínimo 3 caracteres')
    .refine(value => value.trim() !== '', 'A razão social não pode ser vazia'),

  cnpj: z
    .string()
    .min(3, 'O CNPJ deve ter no mínimo 3 caracteres')
    .refine(isValidCNPJ, 'O CNPJ deve ser válido'),

  endereco: enderecoSchema,

  contato: contatoSchema,

  inclusao: z.string().optional(),

  academiaId: z
    .number()
    .int()
    .refine(value => value > 0, 'Selecione uma academia válida'),
});

export type UnitsFormData = z.infer<typeof unitsSchema>;
